import React from 'react';
import { CTAButton, TrustLine } from './CTAButton';
import { BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function Hero() {
  return <header className="bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-76" data-mp="eilc6zjmglae">
      <h1 className="font-heading text-[1.3rem] font-extrabold uppercase leading-[1.08] text-white sm:text-[2.3rem]" data-id="element-77" data-mp="9lbfqzxtf9d2">
        The Complete Ready-to-Use Operating System for{' '}
        <span className="text-brightblue" data-id="element-78" data-mp="128fsjr35grze">Cleaning Professionals</span>
      </h1>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-79" data-mp="x9uspsrt8abh">
        Stop running your cleaning business from scattered notes, messages and
        improvised systems. Access ready-to-use client forms, cleaning
        checklists, quoting tools, scheduling systems, communication templates
        and operational resources. Keep your essential cleaning business
        processes organized in one professional system.
      </p>
      <p className="mt-1 font-heading text-[0.74rem] font-bold uppercase leading-tight text-gold sm:text-sm" data-id="element-80" data-mp="3j8ixz1o3okvr">
        Less time organizing. More control over every cleaning job.
      </p>

      <a href={PURCHASE_ANCHOR} className="mt-2 block" data-id="element-81" data-mp="3o59efq3thihp">
        <img src={BOX_IMAGE} alt="CLEANING READY™ complete 6-in-1 business system box set" className="mx-auto w-full max-w-[250px] drop-shadow-2xl sm:max-w-[320px]" data-id="element-82" data-mp="399jmlbbyab52" />
      </a>

      <div className="mx-auto mt-2 max-w-md" data-id="element-83" data-mp="30ggg5mzq2yjx">
        <CTAButton label="🧹 Yes! I want the complete system" data-id="element-84" data-mp="358hncui19z33" />
        <p className="mt-1.5 font-heading text-[0.66rem] font-extrabold uppercase tracking-[0.12em] text-white sm:text-xs" data-id="element-85" data-mp="35aud3tu19dqp">
          Get Cleaning Ready™ today
        </p>
        <TrustLine className="mt-1 !text-white/75" data-id="element-86" data-mp="2vjpy4u4cxsvv" />
      </div>
    </header>;
}